import { Trip, Content } from './../classes.js';
import { can_display, start_loading, end_loading } from './../function/common.js';

export class cMedia {
	constructor() {
		//construct with some default Media values, we can override them later.
		this.mb_size = 1048576;
		let $gallery = null;
		this.gallery_mode = false;
		this.media = {};
		this.size = {};
		this.video_focus = false;
		
		$('body').on('click', '.trip_gallery--open', {obj: this}, function(e){
			e.preventDefault();
			
			$(this).closest('form').addClass('the-media-focus');
			e.data.obj.open();
			e.data.obj.set_focus($(this).data('set'));
		})
		
		$('body').on('click', '.content_gallery--open', {obj: this}, function(e){
			e.preventDefault();
			
			$(this).closest('form').addClass('the-media-focus');
			e.data.obj.open();
			e.data.obj.set_focus($(this).data('set'));
		})
		
		$('body').on('click', '.media_gallery--open', {obj: this}, function(e){
			e.preventDefault();
			$('.editable').removeClass('the-media-focus');
			e.data.obj.gallery_mode = false;
			
			$(this).closest('.editable').addClass('the-media-focus');
			e.data.obj.open();
			e.data.obj.set_focus($(this).data('set'));
		})
		
		$('body').on('click', '.media_gallery--close', {obj: this}, function(e){
			e.preventDefault();
			$('.editable').removeClass('the-media-focus');
			
			e.data.obj.close();
		})
		
		$('body').on('click', '.media_gallery--add', {obj: this}, function(e){
			e.preventDefault();
			e.data.obj.gallery_mode = true;
			$gallery = $(this).closest('.image__gallery').find('.gallery_images');
			
			$(this).closest('.editable').addClass('the-media-focus');
			
			$gallery.append(`
				<div class="gallery_image the-gallery-focus" data-media="">
					<figure>
						<img src="/system/app/lib/img/placeholder.jpg" alt="Placeholder" />
					</figure>
					<div class="gallery_image_menu">
						<span class="edit-gallery-image material-symbols-outlined">edit</span>
						<span class="drag-gallery-image material-symbols-outlined">drag_pan</span>
						<span class="delete-gallery-image material-symbols-outlined">delete</span>
					</div>
				</div>
			`);
			
			e.data.obj.open();
		})
		
		$('body').on('click', '.edit-gallery-image', {obj: this}, function(e){
			e.data.obj.gallery_mode = true;
			let id = $(this).closest('.gallery_image').attr('data-media');
			$(this).closest('.gallery_image').addClass('the-gallery-focus');
			$(this).closest('.editable').addClass('the-media-focus');
			
			e.data.obj.set_focus(id);
			e.data.obj.open();
		})
		
		$('body').on('click', '.delete-gallery-image', {obj: this}, function(e){
			let id = $(this).closest('.gallery_image').attr('data-media');
			let c_val = $(this).closest('.editable').find('.media_gallery').val();
			let array_val = c_val.split(",");
			let i = 0;
			let track = 0;
			
			for (const gal of array_val) {
				console.log(gal);
				if(id == gal){
					track = i;
				}
				i++;
			}
			array_val.splice(track, 1);
			$(this).closest('.editable').find('.media_gallery').val(array_val.join()); 
			$(this).closest('.gallery_image').remove();
		})
		
		$('body').on('click', '#upload_media', {obj: this}, function(e){
			e.preventDefault();
			
			$('#create_media').click();
		})
		
		$('body').on('change', '#create_media', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.create_media();
		});
		
		$('body').on('click', '#media__elements img, #media__elements video', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.set_focus($(this).data('id'));
		});
		
		$('body').on('click', '#update_media', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.update_media();
		});
		
		$('body').on('click', '#delete_media', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.delete_media();
		});
		
		$('body').on('click', '#set_trip_media', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.update_media();
			e.data.obj.set_trip_media();
		});
	}
	
	open(){
		$('#media_gallery').css("display", "flex").hide().fadeIn(200);
	}
	
	close(){
		this.gallery_mode = false;
		$('.the-media-focus').removeClass('the-media-focus');
		$('.the-gallery-focus').removeClass('the-gallery-focus');
		
		$('#media_gallery').fadeOut(200);
	}
	
	add_gallery_id(id){
		let target = $('.the-media-focus');
		let existing_id = $('.the-gallery-focus').attr('data-media');
		let add = true;
		let c_val = target.find('.media_gallery').val();
		let array_val = c_val.split(",");
		let i = 0;
		
		if(c_val == ''){
			c_val = id;
		}else{
		
			for (const gal of array_val) {
				//if we already have the id, don't add it
				if(id == gal){
					add = false;
				}
				//if we have an existing id, replace it in the array
				if(existing_id == gal){
					array_val[i] = id;
					add = false;
				}
			}
			
			if(add){
				array_val.push(id);
			}
			
			c_val = array_val.join()
		}
		
		return c_val;
	}
	
	remove_gallery_id(){
		
	}
	
	set_media(media = null) {
		$('#media__elements').html(''); //clear our view box
		let $el = '';
		
		if(typeof(media) == 'undefined' || media == null){
			return false;
		}
		
		this.media = media.files;
		this.size = media.size;
		this.set_space_usage(this.size);
		
		if (Object.keys(this.media).length > 0) {
			for (const [file_id, file] of Object.entries(this.media)) {
				if(file.type == "video/mp4"){
					$el = $('<video/>', {
						'data-id': file_id,
						'src': file.path,
						'type': 'video/mp4'
					});
				}else{
					$el = $('<img/>', {
						'src': file.path,
						'data-id': file_id,
						'alt': ''
					});
				}
				
				$('#media__elements').append($el);
			}
			
			this.set_focus(this.media[Object.keys(this.media)[0]].id);
		}
	}
	
	set_placeholder(){
		//update the details content
		$('#details').find('img').attr('src', '/system/app/lib/img/placeholder.jpg');
		$('#active_media').val('');
		$('#active_trip').val('');
		$('#active_alt').val('');
		$('#active_caption').val('');
	}
	
	set_focus(id) {
		if(!can_display(id) || id == 'undefined'){
			return;
		}
		
		let file = this.media[id];
		
		//update the class lists
		$('#media__elements img').removeClass('active');
		$('#media__elements video').removeClass('active');
		$(`#media__elements [data-id="${file.id}"]`).addClass('active');
		
		//update the details content
		if(file.type == 'video/mp4'){
			$('#details').find('video').attr('src', file.path);
			$('#details').find('video').show();
			$('#details').find('img').hide();
			this.video_focus = true;
		}else{
			$('#details').find('img').attr('src', file.path);
			$('#details').find('img').show();
			$('#details').find('video').hide();
			this.video_focus = false;
		}
		$('#active_media').val(file.id);
		$('#active_trip').val(file.trip_id);
		$('#active_alt').val(file.alt);
		$('#active_caption').val(file.caption);
	}
	
	set_space_usage(size = this.size) {
		let media_used = size/this.mb_size;
		
		if(Content.edit){
			$('#media_used').text('N/A');
		}else{
			$('#media_used').text(media_used.toFixed(2));
		}
	}
	
	set_trip_media() {
		let target = $('.the-media-focus');
		let block_id = target.attr('data-block_id');
		let el_id = target.attr('data-el_id');
		let $caption = '';
		
		if(block_id == 'trip'){
			Trip.content[block_id]['featured_media'] = $('#active_media').val();
			target.find('.trip_gallery--open').data('set', $('#active_media').val());
			$('[name="trip_media_id"]').val($('#active_media').val());
			
		}else if(block_id == 'content' && (typeof(el_id) == 'undefined' || el_id == '')){
			Content.content['featured_media'] = $('#active_media').val();
			target.find('.content_gallery--open').data('set', $('#active_media').val());
			$('[name="content_media_id"]').val($('#active_media').val());
			
		}else if(this.gallery_mode){
			Trip.content.b[block_id].e[el_id].c['media_gallery'] = this.add_gallery_id($('#active_media').val());
			target.find('.media_gallery').val(this.add_gallery_id($('#active_media').val()));
			target.find('.the-gallery-focus').find('figure img').attr('src', $('#details__image img').attr('src'));
			target.find('.the-gallery-focus').find('figure img').attr('alt', $('#details__image img').attr('alt'));
			target.find('.the-gallery-focus').attr('data-media', $('#active_media').val());
			
		}else{
			if(!Content.edit){
				//update json
				Trip.content.b[block_id].e[el_id].c['media_id'] = $('#active_media').val();
				Trip.content.b[block_id].e[el_id].c['media_path'] = this.video_focus ? $('#details__image video').attr('src') : $('#details__image img').attr('src');
				Trip.content.b[block_id].e[el_id].c['media_alt'] = $('#active_alt').val();
				Trip.content.b[block_id].e[el_id].c['media_caption'] = $('#active_caption').val();
			}else{
				//update json
				Content.content.e[el_id].c['media_id'] = $('#active_media').val();
				Content.content.e[el_id].c['media_path'] = this.video_focus ? $('#details__image video').attr('src') : $('#details__image img').attr('src');
				Content.content.e[el_id].c['media_alt'] = $('#active_alt').val();
				Content.content.e[el_id].c['media_caption'] = $('#active_caption').val();
			}
			
			target.find('.media_gallery--open').data('set', $('#active_media').val());
		}
			
		//set non gallery for save
		if(!this.gallery_mode){
			target.find('.media_id').val($('#active_media').val());
			if(this.video_focus){
				target.find('figure img').remove();
				target.find('figure video').remove();
				
				target.find('figure').prepend(`<video src="${$('#details__image video').attr('src')}" type="video/mp4" controls />`);
				//target.find('figure video').attr('src', $('#details__image video').attr('src'));
			}else{
				target.find('figure img').remove();
				target.find('figure video').remove();
				
				target.find('figure').prepend(`<img src="${$('#details__image img').attr('src')}" alt="${$('#details__image img').attr('alt')}" />`);
				/*target.find('figure img').attr('src', $('#details__image img').attr('src'));
				target.find('figure img').attr('alt', $('#details__image img').attr('alt'));*/
			}
		}
		
		
		if($('#active_caption').val() != ''){
			if(target.find('figure figcaption').length > 0){
				target.find('figure figcaption').html($('#active_caption').val());
			}else{
				$caption = $('<figcaption/>', {
					'text': $('#active_caption').val()
				});
				target.find('figure').append($caption);
			}
		}else{
			target.find('figure figcaption').remove();
		}
		
		this.close();
	}
	
	add_new_media(f) {
		console.log(f);
		this.media[f.id] = {};
		this.media[f.id]['id'] = f.id;
		this.media[f.id]['name'] = f.file.name;
		this.media[f.id]['path'] = f.path;
		this.media[f.id]['trip_id'] = f.trip_id;
		this.media[f.id]['content_id'] = f.content_id;
		this.media[f.id]['user_id'] = f.user_id;
		this.media[f.id]['size'] = f.file.size;
		this.media[f.id]['type'] = f.file.type;
		this.size = this.size + f.file.size;
		
		//reset Trip objects
		if(!Content.edit){
			Trip.media.files = this.media;
			Trip.media.size = this.size;
		}
		
		//update usage size
		this.set_space_usage(this.size);
		
		const $el = $('<img/>', {
			'src': f.path,
			'data-id': f.id,
			'alt': ''
		});
		$('#media__elements').append($el);
		
		this.set_focus(f.id);
	}
	
	async create_media(){
		//create the form to upload a file
		let media_form = new FormData();
		let file = document.querySelector('#create_media');
		let trip = document.querySelector('#trip_id');
		let content = document.querySelector('#content_id');
		media_form.append('media', file.files[0]);
		media_form.append('trip_id', trip == null ? null : trip.value);
		media_form.append('content_id', content == null ? null : content.value);
		start_loading('Processing Media...');
		
		try {
			let response = await fetch('/api/media/create', {
				method: 'POST',
				body: media_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			if(result.error){
				//error
				end_loading('Error Uploading Media');
			}else{
				this.add_new_media(result.data);
				end_loading('Media Added');
			}
			
		} catch (error) {
			console.error('Error ***', error);
			end_loading('Error Uploading Media');
		}
	}
	
	async update_media(){
		//create the form to upload a file
		let f = document.querySelector('#form__media');
		let media_form = new FormData(f);
		
		if(Content.edit){
			media_form.set('trip_id', 'content');
		}
		
		try {
			let response = await fetch('/api/media/update', {
				method: 'POST',
				body: media_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			if(result.error){
				//error
			}else{
				this.media[result.data.id]['alt'] = result.data.alt;
				this.media[result.data.id]['caption'] = result.data.caption;
				
				//reset Trip objects
				if(Content.edit){
					Content.media.files = this.media;
				}else{
					Trip.media.files = this.media;
				}
				
				$('.flag_success').fadeIn(400).delay(2000).fadeOut(400);
			}
			
		} catch (error) {
			console.error('Error ***', error);
		}
	}
	
	
	async delete_media(){
		//create the form to upload a file
		let f = document.querySelector('#form__media');
		let media_form = new FormData(f);
		
		try {
			let response = await fetch('/api/media/delete', {
				method: 'POST',
				body: media_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			if(result.error){
				//error
			}else{
				delete this.media[result.data.id];
				this.size = this.size - result.data.size;
				
				//reset Trip objects
				if(!Content.edit){
					Trip.media.files = this.media;
					Trip.media.size = this.size;
				}
				
				$(`#media__elements [data-id="${result.data.id}"]`).remove(); //remove the element from the DOM
				this.set_space_usage(); //update our space
				
				if(Object.keys(this.media).length > 0){
					this.set_focus(this.media[Object.keys(this.media)[0]].id); //set the view to the first object in our array
				}else{
					this.set_placeholder();
				}
			}
			
		} catch (error) {
			console.error('Error ***', error);
		}
	}
}